module.exports = __webpack_public_path__ + "img/mico-store-finder.91983f58.webp";